module.exports = __webpack_public_path__ + "img/2-13-4.a30ac378.png";